const DotIcon = (props: any) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx='6' cy='6' r='3' fill='#1FA238' />
    </svg>
  );
};

export default DotIcon;
